module.exports = __webpack_public_path__ + "img/Logo_USA.70892d26.png";